import { apiClient } from '~/api/client';
import { Filter } from '~/components/table/header/filters/useFilters';

export type UpdateColumnsParams = {
  user_id: number;
  update_mask: boolean;
  ui_settings: {
    search_result?: {
      columns: string[];
      dense: boolean;
    };
    profile_transactions?: {
      columns: string[];
      dense: boolean;
    };
    agent_transactions?: {
      columns: string[];
      dense: boolean;
    };
    list_loan_officers?: {
      columns: string[];
      dense: boolean;
    };
    loan_officer_filters?: {
      transactionTypesFilters?: Filter[];
      loanTypesFilters?: Filter[];
      agenciesFilters?: Filter[];
    };
    agent_filters?: {
      agentRolesFilters?: Filter[];
      transactionTypesFilters?: Filter[];
      loanTypesFilters?: Filter[];
      agenciesFilters?: Filter[];
    };
    common_transactions_filters?: {
      agentRolesFilters?: Filter[];
      transactionTypesFilters?: Filter[];
      loanTypesFilters?: Filter[];
      agenciesFilters?: Filter[];
    };
  };
};

export type ShowParams = {
  user_id: number;
  mask_user: boolean;
};

export const update = async ({ user_id, update_mask, ui_settings }: UpdateColumnsParams) =>
  apiClient.put(`/users/${user_id}/ui_settings`, { ui_settings, update_mask });

export const show = async ({ user_id, mask_user }: ShowParams) =>
  apiClient.get(`/users/${user_id}/ui_settings?mask_user=${mask_user}`);
